<template>
    <ValidationObserver
        ref="editingDialog"
        v-slot="{ passes }"
    >
        <BaseDialog
            :showDialog="useDifferentShowDialogProp ? showSpecificEditDialog : showDialog"
            :headline="headline"
            :close="close"
            :maxDialogWidth="maxDialogWidth"
            :maxCardHeight="maxCardHeight"
            :alvqa="alvqa"
        >
            <template v-slot:dialogText>
                <v-container fluid>
                    <slot name="editForm"></slot>
                </v-container>
            </template>

            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-col cols="7"  class="text-left">
                            <slot name="checkboxSlot"></slot>
                        </v-col>
                        <v-spacer />
                        <v-col cols="5" class="text-right">
                            <BaseButton 
                                label="lang_GENERAL_BUTTON_SAVE"
                                @click="passes(save)"
                                :alvqa="alvqa + '-button-save'"
                                :disabled="disabled"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "EditingDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    props: {
        context: String,
        showSnackbar: {
            type: Boolean,
            default: false
        },
        snackbarTextLangConst: String,
        useDifferentShowDialogProp: {
            default: false,
            type: Boolean
        },
        useDifferentSaveFunction: {
            default: false,
            type: Boolean
        },
        differentSaveFunction: {
            type: Function,
            default: () => {}
        },
        useAdditionalSaveFunction: {
            type: Boolean,
            default: false
        },
        additionalSaveFunction: {
            type: Function,
            default: () => {}
        },
        additionalAfterSaveFunction: {
            type: Function,
            default: () => {}
        },
        additionalCloseFunction: {
            type: Function,
            default: () => {}
        },
        maxDialogWidth: {
            type: String,
            default: "800"
        },
        maxCardHeight: {
            type: String,
            default: "800"
        },
        addAtTop: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        /* usually we use unique alvids/ids for identifying the row we want to edit, 
           but in some cases the alvid is not unique in the data table e.g. works in sheets, 
           because an entity can be added multiple times, so we will use the row id (the index of the array)
           to identify the entry.
        */
        useRowIndex: { 
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            alvqa: "editing-dialog"
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowEditingDialog },
            set(show) { this.$store.commit("setShowEditingDialog", show) }
        },
        showSpecificEditDialog: {
            get() { return this.$store.getters['getShow'+ this.context +'EditingDialog'] },
            set(show) { this.$store.commit("setShow"+ this.context +"EditingDialog", show) }
        },

        headline() { return this.$store.getters.getEditingDialogHeadline }
    },
    methods: {
        close() {
            if(this.useDifferentShowDialogProp) this.showSpecificEditDialog = false
            else this.showDialog = false
            
            let defaultValues = this.$store.getters['getDefault' + this.context]
            this.$store.commit('set' + this.context + 'EditingDialogDetails', defaultValues)
            this.$store.commit('setSelected' + this.context, [])
            this.$refs.editingDialog.reset()
            this.additionalCloseFunction()
        },
        save() {
            if (this.useDifferentSaveFunction) {
                this.differentSaveFunction()
                // Show Snackbar for the user if adding was successful
                if(this.showSnackbar) {
                    this.$store.commit('setSnackbar', {
                        type: 'success', 
                        msg: this.$t(this.snackbarTextLangConst)
                    })
                }
                this.close()
                return
            }

            let listItems = this.$store.getters['get' + this.context]
            let editedItem = this.$store.getters['get' + this.context + 'EditingDialogDetails']

            let selectedItem = this.$store.getters['getSelected' + this.context]
            let isNew = (selectedItem === undefined || selectedItem === null) || (Array.isArray(selectedItem) && selectedItem.length === 0) 

            // save process is different depending on if the user is editing an existing item or adding a new one.
            if(isNew) {
                editedItem.id = -(Math.floor(Math.random() * 10000))

                // In case something additional has to happen before assigning the changed object.
                if(this.useAdditionalSaveFunction) editedItem = this.additionalSaveFunction(editedItem)

                if(this.addAtTop) listItems.push(editedItem)
                else listItems.unshift(editedItem)

                this.$store.commit('set' + this.context, listItems)
            } else {
                let index
                if(this.useRowIndex) { // checking if we use index of array of if we need to identify the selected entry first by id
                    index = selectedItem
                } else {
                    index = listItems.findIndex(element => {
                    return element.id === selectedItem
                     })
                }

                // In case something additional has to happen before assigning the changed object.
                if(this.useAdditionalSaveFunction) editedItem = this.additionalSaveFunction(editedItem)
                
                    Object.assign(listItems[index], editedItem)
            }

            // Show Snackbar for the user if adding was successful
            if(this.showSnackbar) {
                this.$store.commit('setSnackbar', {
                    type: 'success', 
                    msg: this.$t(this.snackbarTextLangConst)
                })
            }

            this.additionalAfterSaveFunction()
            this.close()
        }
    }
}
</script>